import { Grid } from '@mui/material';
import { RoutalButton, RoutalPalette, RoutalText, VSpacer } from '@nx-smartmonkey/ui';
import { useIntl } from 'react-intl';

import { useNavigate } from 'react-router';
import Idea from '../assets/img/idea.svg';
import Rocket from '../assets/img/rocket.svg';
import Wallet from '../assets/img/wallet.png';
import { Header } from '../components/Header';
import * as routing from '../constants/Routing';

const ContainerBox = ({
  intlTitle,
  intlSubtitle,
  imgSrc,
}: {
  imgSrc: string;
  intlTitle: string;
  intlSubtitle: string;
}) => {
  const intl = useIntl();
  return (
    <Grid
      container
      justifyContent="flex-start"
      alignItems="center"
      direction="column"
      style={{
        width: `300px`,
        minHeight: `300px`,
        padding: `24px`,
        margin: `0 10px`,
        borderRadius: `12px`,
        textAlign: `center`,
        boxShadow: `0px 10px 30px 0px rgba(35,35,35,0.1)`,
      }}
    >
      <Grid item style={{ height: `140px` }}>
        <img width="120px" src={imgSrc} alt="" />
      </Grid>
      <Grid item style={{ marginBottom: `12px` }}>
        <RoutalText variant="h5">{intl.formatMessage({ id: intlTitle })}</RoutalText>
      </Grid>
      <Grid item>
        <RoutalText variant="body-large">{intl.formatMessage({ id: intlSubtitle })}</RoutalText>
      </Grid>
    </Grid>
  );
};

export const Landing = () => {
  const intl = useIntl();
  const navigate = useNavigate();
  return (
    <>
      <Header />
      <Grid container direction="row" style={{ overflow: `auto`, height: `calc(100vh - 64px)` }}>
        <Grid
          id="jumbo-container"
          container
          alignContent="center"
          justifyContent="center"
          direction="column"
          style={{
            height: `500px`,
            width: `100%`,
            textAlign: `center`,
            //   background: `url(${Background})`,
            //   backgroundSize: `cover`,
            // background: `linear-gradient( -63.43000000000001deg, #333940 15%, #1c2024 85%)`,
            backgroundColor: RoutalPalette.primary00,
          }}
        >
          <RoutalText style={{ color: RoutalPalette.white, fontSize: `3.5em`, fontWeight: `600` }}>
            {intl.formatMessage({ id: `developers.landing.title` })}
          </RoutalText>

          <VSpacer medium />

          <RoutalText style={{ color: RoutalPalette.white, fontSize: `1.875em` }}>
            {intl.formatMessage({ id: `developers.landing.subtitle` })}
          </RoutalText>

          <VSpacer large />

          <Grid item container justifyContent="center">
            <RoutalButton size="large" style={{ fontWeight: `800` }} onClick={() => navigate(routing.APIv2)}>
              {intl.formatMessage({ id: `developers.landing.button` })}
            </RoutalButton>
          </Grid>
        </Grid>
        <Grid
          container
          id="jumbo-container"
          alignContent="center"
          justifyContent="center"
          alignItems="center"
          direction="column"
        >
          <Grid item style={{ margin: `3.65em 0`, padding: `0 20px` }}>
            <RoutalText style={{ fontSize: `1.75em` }}>
              {intl.formatMessage({ id: `developers.landing.main.title` })}
            </RoutalText>
          </Grid>
          <Grid container alignContent="center" justifyContent="center" alignItems="center">
            <ContainerBox
              imgSrc={Idea}
              intlTitle="developers.landing.main.idea.title"
              intlSubtitle="developers.landing.main.idea.subtitle"
            />
            <ContainerBox
              imgSrc={Rocket}
              intlTitle="developers.landing.main.rocket.title"
              intlSubtitle="developers.landing.main.rocket.subtitle"
            />
            <ContainerBox
              imgSrc={Wallet}
              intlTitle="developers.landing.main.wallet.title"
              intlSubtitle="developers.landing.main.wallet.subtitle"
            />
          </Grid>
          <Grid item style={{ margin: `3.65em 0`, padding: `0 20px` }}>
            <RoutalText style={{ fontSize: `1.75em` }}>
              {intl.formatMessage({ id: `developers.landing.main.chat` })}
            </RoutalText>
          </Grid>
        </Grid>
        <Grid
          container
          alignContent="center"
          justifyContent="center"
          style={{ height: `60px`, backgroundColor: `#333940`, color: `white` }}
        >
          <RoutalText style={{ color: RoutalPalette.white }}>
            Copyright © Routal {new Date().getFullYear()}. All right reserved.
          </RoutalText>
        </Grid>
      </Grid>
    </>
  );
};
